import HelpPage from './Help';
import { siteTitle } from '../';

const HelpRoutes = {
		help: {
				path: '/Help/',
				label: 'Help',
				title: `${siteTitle} - Help`,
				component: HelpPage
		}
};

export { HelpRoutes, HelpPage };



// WEBPACK FOOTER //
// ./src/app/containers/Help/index.ts